module.exports = __webpack_public_path__ + "img/SACOMBANK.6bdc8185.svg";